import { Component, HostListener, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { localStorageService } from 'src/app/services/localstorage.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { LogoutModalComponent } from 'src/app/shared/logout-modal/logout-modal.component';
import { filter, Subscription } from 'rxjs';
import { DashboardComponent } from 'src/app/pages/components/dashboard/dashboard.component';
import { DashboardModalComponent } from 'src/app/pages/components/dashboard/dashboard-modal/dashboard-modal.component';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-layout-header',
    templateUrl: './layout-header.component.html',
    styleUrl: './layout-header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TooltipDirective, RouterLink, NgClass]
})
export class LayoutHeaderComponent {
  settingsList = [
    {
      label: 'Profile Settings',
      icon: 'assets/images/icons/user-icon.svg',
      path: 'app/profile',
      shoAction:true
    },
    // {
    //   label: 'Financial Settings',
    //   icon: 'assets/images/icons/users-icon.svg',
    //   path: 'app/financial-settings'
    // },
    {
      label: 'Manage Users',
      icon: 'assets/images/icons/users.svg',
      path: 'app/manage-users',
      shoAction:true
    },
    {
      label: 'Support',
      icon: 'assets/images/icons/support-icon.svg',
      path: 'app/support',
      shoAction:true
    },
    // {
    //   label: 'Disputes',
    //   icon: 'assets/images/icons/shield-dollar.svg',
    //   path: 'app/disputes'
    // }
  ];
  userProfile: any;
  modalRef?: BsModalRef;
  bsModalRef: BsModalRef | undefined;
  showLogout = false;
  search_string = '';
  isDropdownOpen = false;
   showDebtBtn = false;
   agentData:any;
   menuList:any;
   private routerSubscription!: Subscription;
  
  constructor( private vcr: ViewContainerRef, private modalService: BsModalService, private _local: localStorageService, private _router: Router, public _shared: SharedService, public _main: MainService
  ) {
    
    console.log(this.userProfile);
    if (this.userProfile  &&  this.userProfile.doctor_image && this.userProfile.doctor_image.includes('profile_placeholder')) {
      this.userProfile['doctor_image'] = 'assets/images/icons/profile_placeholder.png'
    }
    if (this.agentData  &&  this.agentData.doctor_image && this.agentData.doctor_image.includes('profile_placeholder')) {
      this.agentData['doctor_image'] = 'assets/images/icons/profile_placeholder.png'
    }
    if (this.userProfile && this.userProfile.role_id == 5) {
      this.settingsList[1].shoAction = false
      this.settingsList[2].shoAction = false
    }
    console.log(this.settingsList[2].shoAction);
    
  }
  /**
   * Subscription hides Create Contract across the whole section, the way the
   * prototype does with `.dashboard-main.is-subscription .btn-create-contract
   * { display: none }` — the same section-wide rule it uses for widgets,
   * proposals and claims. Contracts are started from the subscription flow's
   * own entry point, not from this bar.
   */
  get hideCreateContractBtn(): boolean {
    const url = this._router.url.split('?')[0];
    return url === '/app/widget' || url.startsWith('/app/subscription') || url.startsWith('/app/terminal');
  }

  /**
   * Where the Subscription module's back arrow goes, or null when there is
   * nowhere above the current page.
   *
   * The prototype keeps this in the top bar rather than in the page
   * (`#sbp-topnav-back`, mapped by sbpSyncTopBack). Only the members listing
   * needs it here: the plan listing is the root of the section, and every
   * detail screen draws its own bar with its own back arrow — which is why
   * LayoutComponent hides this whole header on those routes.
   */
  get subscriptionBackTarget(): string | null {
    return this._router.url.split('?')[0] === '/app/subscription/members'
      ? '/app/subscription/plans'
      : null;
  }

  goSubscriptionBack(): void {
    const target = this.subscriptionBackTarget;
    if (target) { this._router.navigate([target]); }
  }
  

ngOnInit(): void {
 
  this.userProfile = this._local.customGetItem('userProfileData');
    this.agentData=this._local.customGetItem('userDoctorData');

  this._shared.doctorProfile$.subscribe(response => {
    this.userProfile = response;
    if (
      this.userProfile &&
      ((!this.userProfile.doctor_image && !this.userProfile?.agent_image) ||
        ((this.userProfile.doctor_image && this.userProfile.doctor_image.includes('profile_placeholder')) &&
         (this.userProfile?.agent_image && this.userProfile?.agent_image.includes('profile_placeholder'))))
    ) {
      this.userProfile['doctor_image'] = 'assets/images/icons/profile_placeholder.png';
    }
    if (this.userProfile && this.userProfile.role_id == 5) {
      this.settingsList[1].shoAction = false
      this.settingsList[2].shoAction = false
    }
  });


  this.routerSubscription = this._router.events.subscribe(() => {
    this.showDebtBtn = this._router.url.includes('debt-recovery/list');
  });
  
}



  openNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(0%)';
    }
  }

  logoutModal() {
    const initialState = {
    };
    this.bsModalRef = this.modalService.show(LogoutModalComponent, {
      initialState,
      class: 'modal-dialog-centered'
    });
  }

  /**
   * Falls back to the bundled placeholder when the stored avatar URL cannot be
   * loaded — an expired signed URL, or a host that is unreachable. Without this
   * the broken image left an empty space where the profile control should be.
   */
  onProfileImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    const placeholder = 'assets/images/icons/profile_placeholder.png';
    if (img && !img.src.endsWith(placeholder)) {
      img.src = placeholder;
    }
  }

  showLogoutModal() {
    this.showLogout = true;
  }

  @HostListener('document:click', ['$event.target'])
  onClick(event: EventTarget | null): void {
    if (!(event instanceof Element)) { return; }
    if (!event.classList.contains('lhc') && !event.classList.contains('logout-wrapper') && !event.classList.contains('profile-icon')) {
      this.showLogout = false;
    }
  }

  clearSearch(){
    this.search_string = "";
    this.emitSearch();
  }
  userAction(action: any) {
    this._router.navigate([action.path]);
  }

  emitSearch() {
    // this._shared.search_emitter.next(this.search_string);
  }

  onDropdownToggle(isOpen: boolean) {
    this.isDropdownOpen = isOpen;
  }
  showNotification() {
    const sidenav = document.getElementById('notify-wrapper');
    if (sidenav) {
      sidenav.style.transform = 'translate(0%)';
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    this.routerSubscription?.unsubscribe();
  }

  openEmailModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.modalRef = this.modalService.show(DashboardModalComponent, {
      initialState: {
        modalType: 'VERIFY_EMAIL',
        userProfile: this.userProfile
      },
      class: 'modal-dialog-centered dash-modal'
    });

    this.modalRef.content.closed.subscribe(() => {
      console.log('Email verification modal closed');
      this.modalRef = undefined;
    });
  }


}
